import { mergeActionDefinitions } from "../../utils";

export default mergeActionDefinitions("SelectOrganization", {
  fetchAllOrganizations: [],
  handleFetchAllOrganizationsFailure: ["error"],
  handleFetchAllOrganizationsSuccess: ["organizations"],
  handleLoadClassAmount: ["amount"],
  handleLoadCourseAmount: ["amount"],
  handleLoadGroupsAmount: ["amount"],
  handleLoadUsersAmount: ["amount"],
  handleSelectOrganizationFailure: ["error"],
  handleSelectOrganizationSuccess: ["organization"],
  handleUpdateCoursesAmount: ["amount"],
  loadClassAmount: [],
  loadCourseAmount: [],
  loadGroupsAmount: [],
  loadUsersAmount: [],
  mount: [],
  selectOrganization: ["data"],
  unmount: [],
  updateCoursesAmount: ["amount"],
});
